import script from "./FormValidacao.vue?vue&type=script&setup=true&lang=js"
export * from "./FormValidacao.vue?vue&type=script&setup=true&lang=js"

import "./FormValidacao.vue?vue&type=style&index=0&id=5f5f5909&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f5f5909"]])

export default __exports__